<template>
	<div>
		<!-- ------------------------------註冊信箱開始------------------------------ -->
        <div class="modal fade cm-modal" id="registerEmailModal" tabindex="-1" role="dialog"
            aria-labelledby="registerModalTitle" aria-hidden="true" style="z-index:1100;">
            <div class="modal-dialog modal-dialog-centered cm-modal-registerEmail" role="document">
                <div class="modal-content">
                    <div class="modal-header p-0 text-center cm-modal-registerEmailModal-header">
                        <h4 class='col-12 modal-title text-center text-white'>
                            {{$t('modal.RegisterEmail.Title')}}
                            <button type="button" class="close cm-registerEmail-close" data-dismiss="modal"
                                aria-label="Close">
                                <span aria-hidden="true" @click="clearData">
                                    <img src="@/assets/images/login-close.png">
                                </span>
                            </button>
                        </h4>
                    </div>
                    <div class="modal-body pb-5 cm-modal-registerEmailModal-body">
                        <div class="col-12 px-sm-5 p-0 pt-5 row no-gutters">
                            <div class="col-12 pb-4">{{$t('modal.RegisterEmail.String.Hint1')}}</div>
                            <div class="col-12 pb-4">{{$t('modal.RegisterEmail.String.Hint2')}}</div>
                            <div class="col-12 px-sm-3 px-0 form-group row">
                                <label for="" class="col-sm-2 col-form-label">{{$t('modal.RegisterEmail.Label.Email')}}</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" v-model="inputEmail" v-on:blur="emailInputMonitor" >
                                    <span class="text-danger" v-if="emailPromptString !== ''">{{emailPromptString}}</span>
                                </div>
                            </div>
                            <div class="col-12 mt-sm-5 mt-0 mb-4 row no-gutters">
                                <div v-if="domControl.isWaitingRegisterEmail==true" class="col-sm-6 col-12 px-3 my-1 text-center">
                                    <div class="spinner-border text-warning text-center my-2" role="status"></div>
                                </div>
                                <div v-else class="col-sm-6 col-12 px-3 my-1 d-flex justify-content-center justify-content-sm-end">
                                    <button class="btn w-75" @click="submitBtn">{{$t('modal.RegisterEmail.Button.Confirm')}}</button>
                                </div>

                                <div class="col-sm-6 col-12 px-3 my-1 d-flex justify-content-center justify-content-sm-start">
                                    <button class="btn w-75" @click="closeModal()">{{$t('modal.RegisterEmail.Button.Cancel')}}</button>
                                </div>
                            </div>
                        </div>
                        <img src="@/assets/images/cmi_logo_black.png" class="cm-registerEmailModal-logo-img">
                    </div>
                </div>
            </div>
        </div>
        <!-- ------------------------------註冊信箱結束------------------------------ -->
	</div>
</template>

<script>


import axios from 'axios'
import $ from 'jquery'
import router from '@/router.js'
import store from '@/store/store-controller/store.js'
import * as cmModal from '@/assets/js/cm-modal.js'
import RecaptchaUtil from "@/assets/js/util/RecaptchaUtil.js"
import CookieUtil from "@/assets/js/util/CookieUtil.js";

import ValidatorUtil from '@/assets/js/util/ValidatorUtil.js'

export default {
    data() {
        return {
            inputEmail: "",
            emailPromptString: "",
            domControl: {
                isWaitingRegisterEmail: false
            }
        }
    },
    mounted() {
        const self = this;
        $("#registerEmailModal").on('hidden.bs.modal', function () {
            self.clearData();
        })
    },
    methods: {
        closeModal() {
            $("#registerEmailModal").modal("hide");
            this.clearData();
        },
        clearData() {
            this.inputEmail = "";
            this.emailPromptString = "";
        },
        async submitBtn() {
            await this.emailInputMonitor();

            if(this.emailPromptString != "") {
                return;
            }
            else if(this.emailPromptString == "") {
                const self = this
                // post所需參數
                const storeMainPk = store.getters["storeMemberInfo/getMainPk"];
                const storeClientCookie = CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE);
                if(storeMainPk=="" || storeMainPk==null || storeMainPk==undefined
                    || storeClientCookie=="" || storeClientCookie==null || storeClientCookie==undefined || storeClientCookie==false) {
                    return;
                }

                RecaptchaUtil.startGoogleRecaptchaVerify(
                    process.env.VUE_APP_AUTH_RECAPTCHA_REGISTER_EMAIL,
                    async function(gRecaptchaResponse) {
                        // 設定post參數
                        let bodyFormData = new FormData();
                        bodyFormData.append("clientCookie", storeClientCookie);
                        bodyFormData.append("member.num", storeMainPk);
                        bodyFormData.append("mydomain", "all9fun.com");
                        bodyFormData.append("member.memberDetails[0].mainEmail", self.inputEmail);
                        bodyFormData.append("g-recaptcha-response", gRecaptchaResponse);

                        // 開啟Ajax等待動畫
                        self.domControl.isWaitingRegisterEmail = true

                        // Ajax註冊Email
                        const response = await axios({
                            method: "post",
                            timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                            url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/registerMemberEmailAction.shtml",
                            data: bodyFormData
                        })
                        .catch(function() {
                            alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'))
                        })

                        // 關閉Ajax等待動畫
                        self.domControl.isWaitingRegisterEmail = false

                        // 判斷Ajax結果
                        if(response!=null && response!=undefined) {
                            if(response.data.result == "success") {
                                alert(self.$i18n.t('modal.RegisterEmail.Backend.Response.registerSuccess'));
                                cmModal.closeAllModal();
                                if(router.currentRoute.name != process.env.VUE_APP_ROUTER_HOME) {
                                    location.href = "/";
                                }
                                else {
                                    $("#changePasswordModal").modal("hide");
                                }
                            }
                            else {
                                alert(self.$i18n.t('modal.RegisterEmail.Backend.Response.registerFailed'));
                            }
                        }
                    }
                )
            }
        },
        async emailInputMonitor() {
            // 驗證email字串不為空，且符合格式
            this.emailPromptString = ValidatorUtil.validEmail(this.inputEmail, {
                'req': this.$i18n.t('modal.RegisterEmail.Validate.Email.req'),
                'format': this.$i18n.t('modal.RegisterEmail.Validate.Email.format'),
            })
        },
    },
}
</script>